{
  "expo": {
    "name": "Abo Omar Dashboard",
    "slug": "m5azen-app",
    "scheme": "m5azen-app",
    "owner": "accelerated.store",
    "version": "0.7.26",
    "runtimeVersion": "7",
    "userInterfaceStyle": "light",
    "web": { "bundler": "metro", "output": "single", "lang": "ar", "dir": "rtl", "favicon": "./assets/favicon.png" },
    "platforms": ["web", "ios", "android"],
    "plugins": [
      "@react-native-firebase/app",
      "@react-native-firebase/app-check",
      "expo-image",
      "expo-router",
      "expo-web-browser",
      ["expo-image-picker", { "photosPermission": "Allow $(PRODUCT_NAME) to access your photos" }],
      ["expo-build-properties", { "ios": { "forceStaticLinking": ["RNFBApp"], "useFrameworks": "static" }, "android": {} }],
      ["expo-splash-screen", { "image": "./assets/splash.png", "backgroundColor": "#D53C2B", "imageWidth": 180 }]
    ],
    "experiments": { "reactCompiler": true, "typedRoutes": true, "tsconfigPaths": true },
    "orientation": "portrait",
    "icon": "./assets/icon.png",
    "assetBundlePatterns": ["**/*"],
    "ios": {
      "supportsTablet": true,
      "infoPlist": {
        "ITSAppUsesNonExemptEncryption": false,
        "UIViewControllerBasedStatusBarAppearance": true,
        "CFBundleAllowMixedLocalizations": true,
        "UISupportsRightToLeft": true,
        "LSApplicationQueriesSchemes": ["comgooglemaps", "citymapper", "uber", "lyft", "waze"],
        "NSCameraUsageDescription": "نحتاج إلى الكاميرا لمسح الباركود الخاص بالمنتجات"
      }
    },
    "android": {
      "adaptiveIcon": {
        "foregroundImage": "./assets/adaptive-icon.png",
        "backgroundColor": "#D53C2B"
      },
      "permissions": ["com.google.android.gms.permission.AD_ID", "android.permission.CAMERA"]
    },
    "extra": {
      "router": {},
      "supportsRTL": true,
      "forcesRTL": true,
      "eas": {
        "projectId": "7276501e-7625-4158-bdbe-fb0e8cdb7fb8"
      }
    },
    "updates": {
      "url": "https://u.expo.dev/7276501e-7625-4158-bdbe-fb0e8cdb7fb8",
      "fallbackToCacheTimeout": 5000
    }
  }
}
